import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { USER_KPIS } from './constants';
import { AnalyticsKpiQueryParams, AnalyticsKpiResponse } from './types';
import {
  zodAnalyticsKpiEndpointSchema,
  zodAnalyticsKpiQueryParamsSchema,
  zodAnalyticsKpiResponseSchema,
} from './validations';

/**
 * Fetches the data for a specific analytics KPI from the API with the given query parameters.
 *
 * @param queryParams - The query parameters for fetching the analytics KPI.
 * @returns The data for the analytics KPI.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/User-Activity/operation/get_user_activity_active_users_user_activity_active_users_post
 */
export const fetchAnalyticsKpi = async (
  queryParams: AnalyticsKpiQueryParams,
  options: KyRequestOptions,
) => {
  const url = USER_KPIS.includes(queryParams.kpiName)
    ? ENDPOINT.ANALYTICS.GET_USER_KPI(queryParams.kpiName)
    : ENDPOINT.ANALYTICS.GET_DELIVERY_NOTE_KPI(queryParams.kpiName);

  const response = await vestigasApi
    .post(url, {
      json: queryParams,
      validate: {
        body: zodAnalyticsKpiQueryParamsSchema.transform(
          ({ kpiName: _kpiName, ...rest }) => ({
            ...rest,
          }),
        ),
        pathSegments: zodAnalyticsKpiEndpointSchema,
      },
      ...options,
    })
    .json<AnalyticsKpiResponse | undefined>();

  // Validate the response
  const validatedResponse = zodAnalyticsKpiResponseSchema.parse(response);

  return validatedResponse;
};
